export default __webpack_public_path__ + "static/media/Version (1) - Hobbit_02.600d5e39.jpg";